/**
 * Image fallback utility constants and functions
 */

import defaultImage from '../assets/fallback-img.png';

// Default fallback image
export const DEFAULT_FALLBACK_IMAGE = defaultImage;

// Utility function to get image with fallback
export const getImageWithFallback = (src: string, fallbackSrc?: string): string => {
  return src || fallbackSrc || DEFAULT_FALLBACK_IMAGE;
};
